module.exports = __webpack_public_path__ + "img/ring_r_o_0_1.1c337125.png";